export const gateway = "https://mitch-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://stable-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=7nnr84fe3er3g2kaknvaa0o78k&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fmitch-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "7nnr84fe3er3g2kaknvaa0o78k";
export const BrokerPoolDomainParameter = "stable-brokers";
export const BrokerPoolParameter = "ca-central-1_smmgFhHsy";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://mitch.link.wawanesalife.com";

//updated on Thu Sep 11 2025 00:56:02 GMT+0000 (Coordinated Universal Time)
